import * as React from 'react';

import { parseFormatString } from '@gitbook/app-notifications';

import type { NotificationData } from './notifications';

export interface NotificationTextProps {
    notification: NotificationData;
}

/**
 * Title component to render a notification title or content with emphasis based on the encoded format string.
 */
export function NotificationFormattedTitle(props: NotificationTextProps) {
    const { notification } = props;

    const content = React.useMemo(() => {
        return parseFormatString(notification.content || notification.title);
    }, [notification.content, notification.title]);

    return (
        <div className={notification.isRead ? 'text-muted' : 'text-base'}>
            {content.map((part, index) => {
                return (
                    <React.Fragment key={index}>
                        {part.bold ? (
                            <strong className="font-medium">{part.text}</strong>
                        ) : (
                            <span>{part.text}</span>
                        )}
                        {index < content.length - 1 ? ' ' : ''}
                    </React.Fragment>
                );
            })}
        </div>
    );
}
